import {
	COMPONENT_STATE_INIT_INSTANCE,
	COMPONENT_STATE_UPDATE_INSTANCE,
	COMPONENT_STATE_CLEAR_INSTANCE,
	COMPONENT_STATE_RESET_COMPONENT
} from "orion-components/SharedComponents/ComponentState/redux/actionTypes";

const initialState = {};

/**
 * componentState
 * --------------
 * Generic container reducer for UI components that need per-instance state.
 *
 * State shape:
 * {
 *   [componentKey]: {
 *     [instanceId]: { ...instanceState }
 *   }
 * }
 *
 * Example:
 *   state.componentState.newVideoPlayer["viewer-123"] = {
 *     showControls: true,
 *     someOtherFlag: false
 *   }
 */
const componentState = (state = initialState, action) => {
	switch (action.type) {
		case COMPONENT_STATE_INIT_INSTANCE: {
			const { componentKey, instanceId, initialState: instanceState = {} } = action.payload;

			return {
				...state,
				[componentKey]: {
					...(state[componentKey] || {}),
					[instanceId]: {
						...(state[componentKey]?.[instanceId] || {}),
						...instanceState
					}
				}
			};
		}

		case COMPONENT_STATE_UPDATE_INSTANCE: {
			const { componentKey, instanceId, changes } = action.payload;
			if (!state[componentKey]?.[instanceId]) {
				// optional: auto-create instead of ignoring
				return {
					...state,
					[componentKey]: {
						...(state[componentKey] || {}),
						[instanceId]: { ...(changes || {}) }
					}
				};
			}

			return {
				...state,
				[componentKey]: {
					...(state[componentKey] || {}),
					[instanceId]: {
						...state[componentKey][instanceId],
						...changes
					}
				}
			};
		}

		case COMPONENT_STATE_CLEAR_INSTANCE: {
			const { componentKey, instanceId } = action.payload;
			const componentSlice = state[componentKey];
			if (!componentSlice?.[instanceId]) return state;

			const { [instanceId]: _removed, ...restInstances } = componentSlice;
			return {
				...state,
				[componentKey]: restInstances
			};
		}

		case COMPONENT_STATE_RESET_COMPONENT: {
			const { componentKey } = action.payload;
			const { [componentKey]: _removed, ...rest } = state;
			return rest;
		}

		default:
			return state;
	}
};

export default componentState;
